<template>
  <Manual/>
</template>

<script>
  import Manual from '../components/Manual'

  export default {
    name: 'ManualPage',

    components: {
      Manual,
    },
    computed: {},
    mounted() {}
  }
</script>
